$('.js-select').each(function() {
    $(this).select2({
        width: '100%',
        minimumResultsForSearch: Infinity,
        placeholder: $(this).data('placeholder')
    });
});

const container = document.querySelector('.popup__form__contact__method');
if (container) {
  const checkboxes = Array.from(container.querySelectorAll('input[type="checkbox"]'));
  const phoneCheckbox = checkboxes.find(cb => cb.id === 'method-1');

  checkboxes.forEach(cb => {
    cb.addEventListener('change', e => {
      const checked = checkboxes.filter(c => c.checked);

      if (checked.length === 0) {
        e.target.checked = true;
        return;
      }

      if (
        e.target === phoneCheckbox &&
        !e.target.checked && 
        checked.length === 0
      ) {
        e.target.checked = true;
        return;
      }

      if (
        e.target === phoneCheckbox &&
        !e.target.checked &&
        checked.length === 0
      ) {
        e.target.checked = true;
        return;
      }

      const hasOtherChecked = checkboxes.some(
        c => c !== phoneCheckbox && c.checked
      );

      if (!hasOtherChecked) {
        phoneCheckbox.checked = true;
      }
    }); 
  });
}
    
const buttonPromo = document.querySelector('.add__promo');

if (buttonPromo) {
    buttonPromo.addEventListener('click', e => {
        e.preventDefault();
        buttonPromo.classList.toggle('active');
        document.querySelector('.promo__popup').classList.toggle('open')
    });
}

const buttonPeople = document.querySelector('.add__people');
if (buttonPeople) {
    const popupOriginal = document.querySelector('.people__popup');
    const selectTemplate = document.querySelector('.js-select-template');

    const blockTemplate = popupOriginal.cloneNode(true);
    const itemTemplate = blockTemplate.querySelector('.people__popup__block').cloneNode(true);

    popupOriginal.remove();

    let currentPopup = null;

    function removeSelect2Wrappers(root) {
        const wrappers = root.querySelectorAll('.select2, .select2-container, .select2-container--default');
        wrappers.forEach(w => w.remove());
    }

    function createFreshSelectFromTemplate(oldSelect) {
        if (!selectTemplate) return null;
        const fresh = selectTemplate.cloneNode(true);
        fresh.classList.remove('js-select-template');
        fresh.classList.add('js-select');
        fresh.style.display = '';

        if (oldSelect) {
            if (oldSelect.hasAttribute('name')) fresh.setAttribute('name', oldSelect.getAttribute('name'));
            if (oldSelect.hasAttribute('data-placeholder')) fresh.setAttribute('data-placeholder', oldSelect.getAttribute('data-placeholder'));
        }

        return fresh;
    }

    buttonPeople.addEventListener('click', e => {
        e.preventDefault();

        if (!currentPopup) {
            currentPopup = blockTemplate.cloneNode(true);
            removeSelect2Wrappers(currentPopup);

            const oldSelects = Array.from(currentPopup.querySelectorAll('.js-select'));
            oldSelects.forEach(old => {
                const fresh = createFreshSelectFromTemplate(old);
                if (fresh) old.replaceWith(fresh);
            });

            const parentContainer = buttonPeople.closest('.popup__form__buttons_item');
            if (parentContainer) parentContainer.appendChild(currentPopup);

            buttonPeople.classList.add('active');
            currentPopup.classList.add('open');

            initPopupLogic(currentPopup, itemTemplate);

            $(currentPopup).find('.js-select').select2({
                width: '100%',
                minimumResultsForSearch: Infinity, 
                placeholder: function () {
                    return $(this).data('placeholder');
                }
            });

        } else {
            currentPopup.remove();
            currentPopup = null;
            buttonPeople.classList.remove('active');
        }
    });

    function initPopupLogic(popupEl, itemTemplate) {
    const addBtn = popupEl.querySelector('.people__block__add');
    const blockContainer = popupEl;

    if (addBtn) {
        addBtn.addEventListener('click', e => {
        e.preventDefault();
        const newItem = itemTemplate.cloneNode(true);
        removeSelect2Wrappers(newItem);

        const oldSelect = newItem.querySelector('.js-select');
        if (oldSelect) {
            const freshSelect = createFreshSelectFromTemplate(oldSelect);
            if (freshSelect) oldSelect.replaceWith(freshSelect);
        }

        blockContainer.insertBefore(newItem, addBtn);
        attachDeleteHandler(newItem);

        $(newItem).find('.js-select').select2({
            width: '100%',
            minimumResultsForSearch: Infinity, 
            placeholder: function () {
            return $(this).data('placeholder');
            }
        });
        });
    }

    popupEl.querySelectorAll('.people__popup__block').forEach(attachDeleteHandler);
    }

    function attachDeleteHandler(block) {
        const delBtn = block.querySelector('.button-delete');
        if (!delBtn) return;
        delBtn.addEventListener('click', e => {
            e.preventDefault();
            $(block).find('.js-select').select2('destroy');
            block.remove();
        });
    }

}

document.querySelector('body').addEventListener('click', event => {
    if (document.querySelector('.popup')) {
        if (event.target.closest('.js-open-popup')) {
            event.preventDefault();
            const popupOpener = event.target.closest('.js-open-popup');
            const popupElement = document.querySelector('.popup');
            const isPopupOpen = popupElement.classList.contains('popup__open');
            if (document.querySelector('.header__menu')) {
                document.querySelector('.header__menu').classList.remove('open');
            }
            if (popupOpener.closest('.header__panel__link')) {
                const panelLink = popupOpener.closest('.header__panel__link');
                const wasActive = panelLink.classList.contains('active');
                
                document.querySelectorAll('.header__panel__link').forEach(el => el.classList.remove('active'));
                
                if (document.querySelector('.header__phone')) {
                    document.querySelector('.header__phone').classList.remove('show');
                    document.querySelector('body').classList.remove('body__phones__open');
                    document.querySelector('body').classList.remove('body__menu__open');
                }
                
                if (wasActive) {
                    popupElement.classList.remove('popup__open');
                    document.querySelector('body').classList.remove('body__popup__open');
                } else {
                    panelLink.classList.add('active');
                    popupElement.classList.add('popup__open');
                    document.querySelector('body').classList.add('body__popup__open');
                }
                
            } else if (popupOpener.closest('.header__links__link')) {
                const linkElement = popupOpener.closest('.header__links__link');
                const wasActive = linkElement.classList.contains('active');
                
                if (wasActive) {
                    linkElement.classList.remove('active');
                    popupElement.classList.remove('popup__open');
                    document.querySelector('body').classList.remove('body__popup__open');
                } else {
                    linkElement.classList.add('active');
                    popupElement.classList.add('popup__open');
                    document.querySelector('body').classList.add('body__popup__open');
                }
            } else {
                if (isPopupOpen) {
                    popupElement.classList.remove('popup__open');
                    document.querySelector('body').classList.remove('body__popup__open');
                } else {
                    popupElement.classList.add('popup__open');
                    document.querySelector('body').classList.add('body__popup__open');
                }
            }
        }
        if (event.target.closest('.popup__close')) {
            event.preventDefault();
            document.querySelector('.popup').classList.remove('popup__open');
            document.querySelector('body').classList.remove('body__popup__open');
            document.querySelectorAll('.header__panel__link').forEach(el => el.classList.remove('active'));
            document.querySelectorAll('.header__links__link').forEach(el => el.classList.remove('active'));
        }
        if (!event.target.closest('.js-open-popup') 
                && !event.target.closest('.popup__flex') 
                && !event.target.closest('.button-delete')
                && !event.target.closest('.iti__country-list')     
                && !event.target.closest('.iti__flag-container')  
                && !event.target.closest('.iti__selected-flag')   
                && !event.target.closest('.iti--container')) {  
            document.querySelector('.popup').classList.remove('popup__open');
            document.querySelector('body').classList.remove('body__popup__open');
        }
    }    
})

